// src/constants/projectBidInitialValues.js
import moment from 'moment';

export const baseInitialValues = {
  id: null,
  hotelId: null,
  description: '',
  flag: 'BID',
  status: 'NEW',
  type: 'OTHER_COMMERCIAL_GENERAL_CONTRACTOR',
  qbId: null,
  startDate: moment().format('YYYY-MM-DD HH:mm:ss'),
  endDate: moment().format('YYYY-MM-DD HH:mm:ss'),
  actualEndDate: moment().format('YYYY-MM-DD HH:mm:ss'),
  deadlineDate: null,
  tenantsContractInPlace: false,
  tenantsInsuranceOnFile: false,
  insuranceExpirationDate: moment().format('YYYY-MM-DD HH:mm:ss'),
  contract: null,
  tenantInsurance: null,
  property: {
    id: null,
    name: '',
    phone: '',
    website: '',
    address: {
      id: null,
      type: 'BILLING',
      addressLineOne: '',
      addressLineTwo: '',
      city: '',
      state: '',
      country: 'UNITED_STATES_AMERICA',
      zipCode: '',
      main: true,
      note: '',
      uuid: 0,
    },
  },
  ownership: {
    id: null,
    name: '',
    representativeCompany: '',
    representativeName: '',
    representativePhone: '',
    representativeEmail: '',
    address: {
      id: null,
      type: 'BILLING',
      addressLineOne: '',
      addressLineTwo: '',
      city: '',
      state: '',
      country: 'UNITED_STATES_AMERICA',
      zipCode: '',
      main: true,
      note: '',
      uuid: 0,
    },
  },
  architect: {
    id: null,
    companyName: '',
    representativeName: '',
    representativePhone: '',
    address: {
      id: null,
      type: 'BILLING',
      addressLineOne: '',
      addressLineTwo: '',
      city: '',
      state: '',
      country: 'UNITED_STATES_AMERICA',
      zipCode: '',
      main: true,
      note: '',
      uuid: 0,
    },
  },
  designer: {
    id: null,
    companyName: '',
    representativeName: '',
    representativePhone: '',
    address: {
      id: null,
      type: 'BILLING',
      addressLineOne: '',
      addressLineTwo: '',
      city: '',
      state: '',
      country: 'UNITED_STATES_AMERICA',
      zipCode: '',
      main: true,
      note: '',
      uuid: 0,
    },
  },
  typeDescription: 'Other Commercial General Contractor',
  basePrice: 0,
  selections: 0,
  purchaseOrders: 0,
  totalPrice: 0,
  invoiced: 0,
  payments: 0,
  amountDue: 0,
  basic: false,
};

export function buildProjectBidInitialValues(record = {}, customer = {}) {
  // começa com os valores-base + possíveis overrides de record
  const data = { ...baseInitialValues, ...record };

  // garante customerId sempre presente
  if (customer.id) {
    data.customerId = customer.id;
  }

  // se vier um registro existente, monta architect/designer customizados
  if (record && record.id) {
    // architect
    data.architect = {
      id: record.architect?.id ?? null,
      companyName: record.architect?.companyName ?? '',
      representativeName: record.architect?.representativeName ?? '',
      representativePhone: record.architect?.representativePhone ?? '',
      address: {
        id: record.architect?.address?.id ?? null,
        type: record.architect?.address?.type ?? 'BILLING',
        addressLineOne: record.architect?.address?.addressLineOne ?? '',
        addressLineTwo: record.architect?.address?.addressLineTwo ?? '',
        city: record.architect?.address?.city ?? '',
        state: record.architect?.address?.state ?? '',
        country: record.architect?.address?.country ?? 'UNITED_STATES_AMERICA',
        zipCode: record.architect?.address?.zipCode ?? '',
        main: record.architect?.address?.main ?? true,
        note: record.architect?.address?.note ?? '',
        uuid: record.architect?.address?.uuid ?? 0,
      },
    };

    // designer
    data.designer = {
      id: record.designer?.id ?? null,
      companyName: record.designer?.companyName ?? '',
      representativeName: record.designer?.representativeName ?? '',
      representativePhone: record.designer?.representativePhone ?? '',
      address: {
        id: record.designer?.address?.id ?? null,
        type: record.designer?.address?.type ?? 'BILLING',
        addressLineOne: record.designer?.address?.addressLineOne ?? '',
        addressLineTwo: record.designer?.address?.addressLineTwo ?? '',
        city: record.designer?.address?.city ?? '',
        state: record.designer?.address?.state ?? '',
        country: record.designer?.address?.country ?? 'UNITED_STATES_AMERICA',
        zipCode: record.designer?.address?.zipCode ?? '',
        main: record.designer?.address?.main ?? true,
        note: record.designer?.address?.note ?? '',
        uuid: record.designer?.address?.uuid ?? 0,
      },
    };

    // hotelId customizado se vier no record
    data.hotelId = record.hotelId;
  }

  return data;
}
